var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dynamic-toolbar document-state"},[_c('span',{staticClass:"text-14px fw-500 errored"},[_vm._v("*")]),_c('span',{staticClass:"text-12px fw-300 white-text"},[_vm._v(_vm._s(_vm.$t('Required field')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }